/* eslint-disable jsx-a11y/interactive-supports-focus */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useEffect, useState } from 'react';
import * as Sentry from '@sentry/browser';
import Add from '@mui/icons-material/Add';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import Box from '@mui/material/Box';
import OpenInNew from '@mui/icons-material/OpenInNew';
import NotifyButton from '../NotifyButton';
import CustomLoader from '../CommonComponents/CustomLoader';
import { useNurseryContext } from '../../contexts/NurseryContext';
const classes = {
    loaderRoot: (theme) => ({
        color: theme.palette.background.default,
        padding: theme.spacing(0, 0.65),
    }),
    select: {
        padding: 0,
        boxShadow: 'none',
        border: '1px solid #d8d8d8',
        '& ul': {
            padding: 0,
            backgroundColor: '#fff',
        },
    },
    menuItem: {
        color: '#5B6A74',
        padding: '15px 0 0',
        cursor: 'pointer',
        '& .item_wrapper': {
            borderBottom: '1px solid #d3d3d3',
            margin: '0 15px',
            display: 'flex',
            alignItems: 'flex-start',
            flexDirection: 'column',
            width: '100%',
            paddingBottom: '15px',
        },
        '& p': {
            marginBottom: 0,
            fontSize: '14px',
            fontWeight: 'bold',
            lineHeight: '19px',
        },
        '& span': {
            fontSize: '12px',
            fontWeight: 400,
            lineHeight: '20px',
        },
        '& .shopify_more_options': {
            display: 'flex',
            alignItems: 'center',
            padding: '0 12px 15px',
        },
    },
    noBorder: {
        border: 'none',
    },
    noMargin: {
        margin: 0,
    },
    hide: {
        display: 'none',
    },
};
const ShopifyBuy = ({ setOpenOptions, isAvailable = false, notForSale = () => { }, mainTitle = '', onAddToShopifyCart, plant: { variants, django_pk: djangoPk, affiliated_links: affiliatedLinks, nurseries, }, }) => {
    const { isNursery, nurseryName, nurserySlug } = useNurseryContext();
    const [shopifyProduct, setShopifyProduct] = useState([]);
    const [filteredLinks, setFilteredLinks] = useState(affiliatedLinks);
    const [selectedVariant, setSelectedVariant] = useState('none');
    const [addingToCart, setAddingToCart] = useState(false);
    const [openSelect, setOpenSelect] = useState(false);
    const [isAffiliatedLink, setIsAffiliatedLink] = useState(false);
    const availableOptions = (shopifyProduct === null || shopifyProduct === void 0 ? void 0 : shopifyProduct.length) + (filteredLinks === null || filteredLinks === void 0 ? void 0 : filteredLinks.length);
    const getFilteredAffiliatedLinks = () => {
        let filteredItems = affiliatedLinks;
        if (isNursery) {
            filteredItems = affiliatedLinks.filter((item) => item.nursery.name === nurseryName);
        }
        setFilteredLinks(filteredItems);
    };
    const getShopifyProductDetails = () => {
        let product = variants.filter((variant) => variant.available);
        if (isNursery && !isAvailable) {
            product = product
                .filter((variant) => variant.fulfillment_service === nurserySlug);
        }
        setShopifyProduct(product);
        if ((affiliatedLinks === null || affiliatedLinks === void 0 ? void 0 : affiliatedLinks.length) > 0) {
            getFilteredAffiliatedLinks();
        }
    };
    const getSaleUrl = () => {
        let item;
        if (isAffiliatedLink) {
            item = affiliatedLinks.find((link) => link.id === selectedVariant);
        }
        if (item) {
            return item.sale_url;
        }
        return '';
    };
    const handleAddToCart = async (e) => {
        e.preventDefault();
        if (selectedVariant === 'none' && !openSelect) {
            setOpenSelect(true);
        }
        else {
            setAddingToCart(true);
            await onAddToShopifyCart({ id: selectedVariant }, 1, djangoPk);
            setAddingToCart(false);
        }
    };
    const handleChange = (event) => {
        const id = event.target.value;
        const mergeArray = [...shopifyProduct, ...filteredLinks];
        mergeArray.forEach((item) => {
            if (item.id === id) {
                setSelectedVariant(item.id);
            }
        });
    };
    const closeSelect = () => {
        setOpenSelect(false);
    };
    useEffect(() => {
        if ((shopifyProduct === null || shopifyProduct === void 0 ? void 0 : shopifyProduct.length) === 0 && (filteredLinks === null || filteredLinks === void 0 ? void 0 : filteredLinks.length) === 0) {
            if (notForSale) {
                try {
                    notForSale();
                }
                catch (error) {
                    Sentry.captureException(error);
                }
            }
        }
    }, [shopifyProduct, filteredLinks]);
    useEffect(() => {
        getShopifyProductDetails();
    }, [variants]);
    useEffect(() => {
        const item = shopifyProduct.find((product) => product.id === selectedVariant);
        setIsAffiliatedLink(!item && selectedVariant !== 'none');
    }, [selectedVariant]);
    return (shopifyProduct === null || shopifyProduct === void 0 ? void 0 : shopifyProduct.length) === 0 && (filteredLinks === null || filteredLinks === void 0 ? void 0 : filteredLinks.length) === 0 ? (React.createElement("div", { className: "notify_container" },
        React.createElement(NotifyButton, { showTitle: false, djangoPk: djangoPk, plantName: mainTitle }),
        (nurseries === null || nurseries === void 0 ? void 0 : nurseries.length) > 0 && (React.createElement(Box, { sx: [classes.menuItem, classes.noBorder, classes.noMargin] },
            React.createElement("div", { onClick: () => setOpenOptions(true), role: "button", className: "shopify_more_options" },
                React.createElement(Add, { fontSize: "small", style: { marginRight: 5 } }),
                React.createElement("p", null, "More Options")))))) : (React.createElement("div", { className: "shopify_btn" },
        React.createElement(Select, { open: openSelect, onClick: () => {
                if (!openSelect)
                    setOpenSelect(true);
            }, onClose: closeSelect, onBlur: closeSelect, defaultValue: "none", id: "menu", MenuProps: {
                sx: { paper: classes.select },
                anchorOrigin: {
                    vertical: 'bottom',
                    horizontal: 'center',
                },
                transformOrigin: {
                    vertical: 'bottom',
                    horizontal: 'center',
                },
            }, onChange: handleChange, className: "variant_dd_wrapper", inputProps: { 'aria-label': 'Without label' }, value: selectedVariant },
            React.createElement(MenuItem, { sx: [classes.menuItem, classes.hide], value: "none" },
                React.createElement("p", { className: "plant_info" }, "Select a size"),
                React.createElement("span", { className: "select_shipping_info" },
                    availableOptions,
                    ' ',
                    "option",
                    availableOptions > 1 ? 's' : '',
                    ' ',
                    "available")),
            (shopifyProduct === null || shopifyProduct === void 0 ? void 0 : shopifyProduct.length) > 0 && (shopifyProduct === null || shopifyProduct === void 0 ? void 0 : shopifyProduct.map((item) => {
                var _a;
                return (React.createElement(MenuItem, { sx: classes.menuItem, key: item.id, value: item.id },
                    React.createElement("div", { className: "item_wrapper" },
                        React.createElement("p", { className: "plant_info" },
                            item.title,
                            ' ',
                            "| $",
                            item.price),
                        React.createElement("span", { className: "select_shipping_info" }, (_a = item === null || item === void 0 ? void 0 : item.nursery) === null || _a === void 0 ? void 0 : _a.shipping_info))));
            })),
            (filteredLinks === null || filteredLinks === void 0 ? void 0 : filteredLinks.length) > 0 && filteredLinks.map((link) => {
                var _a, _b;
                return (React.createElement(MenuItem, { sx: classes.menuItem, key: link.id, value: link.id },
                    React.createElement("div", { className: "item_wrapper" },
                        link.size || link.price ? (React.createElement("p", { className: "plant_info" },
                            link.size,
                            ' ',
                            "| $",
                            link.price)) : React.createElement("p", { className: "plant_info" }, (_a = link.nursery) === null || _a === void 0 ? void 0 : _a.name),
                        React.createElement("span", { className: "select_shipping_info" }, (_b = link === null || link === void 0 ? void 0 : link.nursery) === null || _b === void 0 ? void 0 : _b.shipping_info))));
            }),
            React.createElement(MenuItem, { onClick: () => setOpenOptions(true), sx: [classes.menuItem, classes.noBorder], value: "more-options" },
                React.createElement("div", { role: "button", className: "shopify_more_options" },
                    React.createElement(Add, { fontSize: "small", style: { marginRight: 5 } }),
                    React.createElement("p", null, "More Options")))),
        isAffiliatedLink ? (React.createElement("a", { target: "_blank", rel: "noopener nofollow sponsored", href: getSaleUrl() },
            React.createElement("button", { type: "button", className: "btn primary" },
                React.createElement(OpenInNew, { sx: { padding: 0, marginRight: 2 } }),
                "Buy from nursery"))) : (React.createElement("button", { type: "button", className: "btn primary", id: "addcart_btn", onClick: handleAddToCart, disabled: addingToCart },
            React.createElement("img", { className: "add_to_cart", src: `${process.env.STATIC_PATH}/img/add-to-cart.png`, alt: "Add to cart" }),
            addingToCart ? (React.createElement(CustomLoader, { loaderSx: classes.loaderRoot, loaderAttributes: { size: 20, thickness: 5 } })) : 'Add to Cart'))));
};
export default ShopifyBuy;
